export default "__VITE_ASSET__Bm6M8PRk__"